<div class="relative overflow-hidden flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between p-6 rounded-2xl border border-white/10 shadow-xl group"
      style="background-image: url('pexels-expect-best-79873-323780.jpg'); background-size: cover; background-position: center;">

      <!-- Dark overlay -->
      <div class="absolute inset-0 bg-bg-base/40 z-0 pointer-events-none"></div>
      
      <!-- Glow effect -->
      <div class="absolute -right-20 -top-20 h-40 w-40 rounded-full bg-primary/20 blur-3xl pointer-events-none z-0"></div>

      <div class="relative z-10 min-w-0">
            <h1
                  class="text-xl font-extrabold text-white sm:text-2xl lg:text-3xl tracking-tight leading-none flex items-center gap-2 shadow-text">
                  <span class="h-2 w-2 rounded-full bg-primary animate-pulse shadow-glow"></span>
                  {{ 'developerDashboard.header.title' | translate }}
            </h1>
            <p class="mt-1.5 text-xs text-white/80 font-medium sm:text-sm">
                  {{ 'developerDashboard.header.subtitle' | translate }}
            </p>
      </div>

      <div class="relative z-10 flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-between lg:w-auto lg:justify-end">
            <div
                  class="flex items-center justify-between gap-4 border-t border-white/10 pt-4 sm:justify-end sm:border-t-0 sm:pt-0 sm:border-s sm:border-white/10 sm:ps-5">

                  <div class="min-w-0">
                        <div class="truncate text-sm font-bold text-white tracking-wide shadow-text">
                              {{ 'developerDashboard.header.companyName' | translate }}
                        </div>
                        <div class="text-[11px] font-semibold text-primary mt-0.5 uppercase tracking-wider font-mono shadow-text">
                              {{ 'developerDashboard.header.role' | translate }}
                        </div>
                  </div>

                  <div
                        class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-black/30 backdrop-blur-md text-white shadow-lg border border-white/10 sm:h-12 sm:w-12 transition-transform duration-300 hover:scale-105 hover:bg-black/40 hover:border-primary/50 shadow-inner">
                        <i class="fas fa-building text-sm sm:text-base text-white/80 group-hover:text-primary transition-colors"></i>
                  </div>

            </div>
      </div>

</div>